<div class="header">
  <div class="title">New Report</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="addContactForm">
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Name</mat-label>
      <input matInput [formControlName]="'name'" />
    </mat-form-field>
  </div>

  <!-- Body -->

  <div class="actions">
    <div class="formatting">
      <treo-message
        *ngIf="message"
        [appearance]="message.appearance"
        [showIcon]="message.showIcon"
        [type]="message.type"
        [@shake]="message.shake"
      >
        {{ message.content }}
      </treo-message>
    </div>
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        type="submit"
        [disabled]="addContactForm.pristine || addContactForm.invalid"
        (click)="saveAndClose()"
      >
        <span>Save</span>
      </button>
    </div>
  </div>
</form>
